import { Controller } from "@hotwired/stimulus"
import { create as createNoUiSlider } from 'nouislider'
import { enter, leave } from 'el-transition'

import "nouislider/src/nouislider.less"

export default class extends Controller {
  static values = {
    rmLowest: Number,
    rmHighest: Number,
  }

  static targets = [
    "HybridsContainer", "ListingContainer", "ListingMain", "ListingBulletsContainer", "ListingSecondary",
    "ClearFiltersButton", "ClearFiltersButtonFilterBar", "ResultsCount",
    "FiltersContainer", "FilterToggleText", "FilterToggleOpenCaret", "FilterToggleCloseCaret",
    "FilterRmRange", "RmRangeText",
    "FilterContainerCategoryPerformer", "FilterContainerCategoryAdaptable", "FilterContainerCategoryTough",
    "FilterContainerPurpose", "FilterContainerDroughtTolerance", "FilterContainerSoilType",
    "FilterContainerDiseaseToleranceGoss", "FilterContainerDiseaseToleranceGray", "FilterContainerDiseaseToleranceBlight", "FilterContainerDiseaseToleranceAnthracnose",
    "FilterCheckboxCategoryPerformer", "FilterCheckboxCategoryAdaptable", "FilterCheckboxCategoryTough",
    "FilterRadioPurposeSilage", "FilterRadioPurposeGrain", "FilterRadioPurposeFoodPlot", "FilterRadioPurposeFoodGrade", "FilterRadioDroughtToleranceDryland", "FilterRadioDroughtToleranceIrrigated", "FilterRadioSoilTypeProductive",  "FilterRadioSoilTypeMarginal", "FilterCheckboxDiseaseToleranceGoss", "FilterCheckboxDiseaseToleranceGray", "FilterCheckboxDiseaseToleranceBlight", "FilterCheckboxDiseaseToleranceAnthracnose",
    "ComparisonsContainer", "ComparisonsButton", "ComparisonsCount",  "CompareButton", "ComparisonTableColumn",
    "QuantityInput", "AddToCartButton", "ModalContent", "ModalContentContainer",
    "AddToCartModal", "AddToCartModalBgOverlay", "AddToCartModalContent", "AddToCartModalQuantityInput", "AddToCartModalSubmitButton",
    "FoodPlotLabel", "FoodGradeLabel",
    "StateSelectInput"
  ]

  hybridFinderController() {
    return this.application.getControllerForElementAndIdentifier(document.querySelector("[data-controller='hybrid-finder']"), 'hybrid-finder')
  }

  initialize() {
    this.listings = []
    this.listingMatches = []
    this.openListings = []
    this.comparisons = []
    this.mobileFiltersExpanded = false

    this.defaultRmRangeLow = this.rmLowestValue
    this.defaultRmRangeHigh = this.rmHighestValue
    this.rmRangeLow = this.rmLowestValue
    this.rmRangeHigh = this.rmHighestValue
    this.categoryPerformer = false
    this.categoryAdaptable = false
    this.categoryTough = false
    this.purpose = null
    this.droughtTolerance = null
    this.soilType = null
    this.diseaseToleranceGoss = false
    this.diseaseToleranceGray = false
    this.diseaseToleranceBlight = false
    this.diseaseToleranceAnthracnose = false
    this.selectedState = null

    this.ListingContainerTargets.map((listingContainer) => {
      var listingObject = JSON.parse(listingContainer.dataset.json)

      this.listings.push(listingObject)
      this.listingMatches.push(listingObject)
    })
  }

  connect() {
    this.element[this.identifier] = this

    this.initRmSlider()
    this.showPopupViaUrl()
    setTimeout(this.adjustBulletsTextSize.bind(this), 500)
  }

  initRmSlider() {
    createNoUiSlider(this.FilterRmRangeTarget, {
      range: {
        'min': this.defaultRmRangeLow,
        'max': this.defaultRmRangeHigh,
      },
      step: 1,
      start: [this.defaultRmRangeLow, this.defaultRmRangeHigh],
      margin: 1,
      connect: true
    })

    this.FilterRmRangeTarget.noUiSlider.on('slide', this.onRmSlide.bind(this))
  }

  showPopupViaUrl() {
    let urlParam = window.location.pathname.split("/")[2]

    if (urlParam) {
      switch(urlParam.toLowerCase()) {
        case "h87c9":
          urlParam = "h87c"
          break
        case "h104sc":
          urlParam = "h104s"
          break
        case "h113c":
          urlParam = "h113"
          break
        case "h117sc9":
          urlParam = "h117sc"
          break
        default:
          urlParam = urlParam
      }

      const target = this.ListingMainTargets.find((target) => target.dataset.urlParam.toLowerCase() == urlParam.toLowerCase())
      if (target) {
        setTimeout(() => target.click(), 500)
      }
    }
  }

  adjustTopMarginForNavbar() {
    this.ModalContentTargets.forEach((modalContent) => {
      modalContent.classList.add("sm:!mt-18", "xl:!mt-12")
    })
    this.ModalContentContainerTargets.forEach((modalContentContainer) => {
      modalContentContainer.classList.add("!mt-12", "sm:!mt-0")
    })
  }

  adjustBulletsTextSize() {
    this.ListingBulletsContainerTargets.forEach((bulletContainer) => {
      let textRectHeights = []
      const textTargets = bulletContainer.querySelectorAll("li.list-disc")
      textTargets.forEach((textTarget) => {
        textRectHeights.push(textTarget.getBoundingClientRect().height)
      })
      const lineHeight = parseInt(window.getComputedStyle(textTargets[0]).getPropertyValue("line-height"), 10)
      const numLines = textRectHeights.reduce((accumulator, curr) => accumulator + curr) / lineHeight

      if (numLines >= 6) {
        bulletContainer.classList.add("text-2sm", "sm:text-xs")
      }
    })
  }

  onAddToCartClick(e) {
    const listingId = e.currentTarget.dataset.listingId
    const quantityInput = this.QuantityInputTargets.find((input) => input.dataset.listingId == listingId)
    const quantityValue = parseInt(quantityInput.value)

    if (!Number.isInteger(quantityValue) || quantityValue <= 0) {
      e.stopPropagation()
      e.preventDefault()
      quantityInput.classList.add("border-red-500", "border-4")
      setTimeout(() => {
        this.AddToCartButtonTargets.map((button) => window.mrujs.enableElement(button))
        this.AddToCartModalSubmitButtonTargets.map((button) => window.mrujs.enableElement(button))
      }, 100)
    }
  }

  onQuantityInput(e) {
    if (e.target.classList.contains("border-red-500")) {
      e.target.classList.remove("border-red-500", "border-4")
    }
  }

  onAddToCartModalSubmitClick(e) {
    const listingId = e.currentTarget.dataset.listingId
    const quantityInput = this.AddToCartModalQuantityInputTargets.find((input) => input.dataset.listingId == listingId)
    const quantityValue = parseInt(quantityInput.value)

    if (!Number.isInteger(quantityValue) || quantityValue <= 0) {
      e.stopPropagation()
      e.preventDefault()
      quantityInput.classList.add("!border-red-500", "!border-4")
      setTimeout(() => {
        this.AddToCartButtonTargets.map((button) => window.mrujs.enableElement(button))
        this.AddToCartModalSubmitButtonTargets.map((button) => window.mrujs.enableElement(button))
      }, 100)
    }
  }

  onAddToCartModalQuantityInput(e) {
    if (e.target.classList.contains("!border-red-500")) {
      e.target.classList.remove("!border-red-500", "!border-4")
    }
  }

  onCardAddToCartClick(e) {
    e.stopPropagation()

    const listingId = e.currentTarget.dataset.listingId
    const modal = this.AddToCartModalTargets.find((target) => target.dataset.listingId == listingId)
    const modalBg = this.AddToCartModalBgOverlayTargets.find((target) => target.dataset.listingId == listingId)
    const modalContent = this.AddToCartModalContentTargets.find((target) => target.dataset.listingId == listingId)

    modal.classList.remove('hidden', 'pointer-events-none')
    document.querySelector('html').style.overflow = 'hidden'
    enter(modalBg)
    enter(modalContent)

    setTimeout(() => this.AddToCartModalQuantityInputTarget.focus(), 250)
  }

  onCardCallForInventoryClick(e) {
    e.stopPropagation()

    const phoneCallUrl = e.currentTarget.dataset.phoneCallUrl
    const link = document.createElement('a')

    link.setAttribute('href', phoneCallUrl)
    link.setAttribute('target', '_blank')
    link.setAttribute('rel', 'noopener noreferrer')

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  onAddToCartModalCloseClick(e) {
    e.stopPropagation()

    const listingId = e.currentTarget.dataset.listingId
    const modal = this.AddToCartModalTargets.find((target) => target.dataset.listingId == listingId)
    const modalBg = this.AddToCartModalBgOverlayTargets.find((target) => target.dataset.listingId == listingId)
    const modalContent = this.AddToCartModalContentTargets.find((target) => target.dataset.listingId == listingId)

    leave(modalBg)
    leave(modalContent)
    document.querySelector('html').style.overflow = ''
    setTimeout(() => modal.classList.add('hidden', 'pointer-events-none'), 300)
  }

  onRmSlide(values) {
    values = values.map((value) => parseInt(value))
    this.rmRangeLow = values[0]
    this.rmRangeHigh = values[1]
    this.RmRangeTextTarget.innerHTML = `${values[0]} - ${values[1]} days`
    this.filterMatches()
    this.displayClearFilters()
  }

  onClearFilters() {
    this.rmRangeLow = this.defaultRmRangeLow
    this.rmRangeHigh = this.defaultRmRangeHigh
    this.FilterRmRangeTarget.noUiSlider.set([this.defaultRmRangeLow, this.defaultRmRangeHigh])
    this.RmRangeTextTarget.innerHTML = `${this.defaultRmRangeLow} - ${this.defaultRmRangeHigh} days`
    this.categoryPerformer = false
    this.FilterContainerCategoryPerformerTarget.classList.remove("bg-highlight-blue", "rounded")
    this.FilterCheckboxCategoryPerformerTarget.checked = false
    this.categoryAdaptable = false
    this.FilterContainerCategoryAdaptableTarget.classList.remove("bg-highlight-blue", "rounded")
    this.FilterCheckboxCategoryAdaptableTarget.checked = false
    this.categoryTough = false
    this.FilterContainerCategoryToughTarget.classList.remove("bg-highlight-blue", "rounded")
    this.FilterCheckboxCategoryToughTarget.checked = false
    this.purpose = null
    this.FilterContainerPurposeTargets.map((target) => target.classList.remove("bg-highlight-blue", "rounded"))
    this.FilterRadioPurposeSilageTarget.checked = false
    this.FilterRadioPurposeGrainTarget.checked = false
    this.FilterRadioPurposeFoodPlotTarget.checked = false
    this.FilterRadioPurposeFoodGradeTarget.checked = false
    this.droughtTolerance = null
    this.FilterContainerDroughtToleranceTargets.map((target) => target.classList.remove("bg-highlight-blue", "rounded"))
    this.FilterRadioDroughtToleranceDrylandTarget.checked = false
    this.FilterRadioDroughtToleranceIrrigatedTarget.checked = false
    this.soilType = null
    this.FilterContainerSoilTypeTargets.map((target) => target.classList.remove("bg-highlight-blue", "rounded"))
    this.FilterRadioSoilTypeProductiveTarget.checked = false
    this.FilterRadioSoilTypeMarginalTarget.checked = false
    this.diseaseToleranceGoss = false
    this.FilterContainerDiseaseToleranceGossTarget.classList.remove("bg-highlight-blue", "rounded")
    this.FilterCheckboxDiseaseToleranceGossTarget.checked = false
    this.diseaseToleranceGray = false
    this.FilterContainerDiseaseToleranceGrayTarget.classList.remove("bg-highlight-blue", "rounded")
    this.FilterCheckboxDiseaseToleranceGrayTarget.checked = false
    this.diseaseToleranceBlight = false
    this.FilterContainerDiseaseToleranceBlightTarget.classList.remove("bg-highlight-blue", "rounded")
    this.FilterCheckboxDiseaseToleranceBlightTarget.checked = false
    this.diseaseToleranceAnthracnose = false
    this.FilterContainerDiseaseToleranceAnthracnoseTarget.classList.remove("bg-highlight-blue", "rounded")
    this.FilterCheckboxDiseaseToleranceAnthracnoseTarget.checked = false
    this.selectedState = null
    if (this.hasStateSelectInputTarget) {
      this.StateSelectInputTarget.value = ''
    }

    this.filterMatches()
    this.displayClearFilters()
    if (this.hybridFinderController()) {
      this.hybridFinderController().onClearFilters()
    }
  }

  onOpenModal(e) {
    const listingTitle = e.currentTarget.dataset.urlParam
    window.history.replaceState({}, `${listingTitle} details - Hybrid85`, `/hybrids/${listingTitle}`)
    let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches

    if (isMobile) {
      this.ListingMainTargets.forEach((mainTarget) => {
        mainTarget.classList.add("!border-0")
      })
    }
  }

  onCloseModal(e) {
    window.history.replaceState({}, 'Hybrids - Hybrid85', `/hybrids`)
    let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches
    if (isMobile) {
      this.ListingMainTargets.forEach((mainTarget) => {
        mainTarget.classList.remove("!border-0")
      })
    }
  }

  onCompareCheckClick(e) {
    e.stopPropagation()

    var listingId = e.target.dataset.id
    const elem = this.CompareButtonTargets.find((target) => target.dataset.id == listingId)
    const listingContainer = this.ListingMainTargets.find((target) => target.dataset.id == listingId)

    if (this.comparisons.find((listing) => listing.id == listingId)) {
      this.comparisons = this.comparisons.filter((listing) => listing.id != listingId)
      elem.classList.remove("bg-ux-blue-400", "!text-white", "hover:bg-gray-500", "border-0")
      elem.querySelector('[data-icon]').classList.add("hidden")
      listingContainer.classList.remove("!border-3", "!border-ux-blue-400")
    } else {
      this.comparisons.push(this.listings.find((listing) => listing.id == listingId))
      elem.classList.add("bg-ux-blue-400", "!text-white", "hover:bg-gray-500", "border-0")
      elem.querySelector('[data-icon]').classList.remove("hidden")
      listingContainer.classList.add("!border-3", "!border-ux-blue-400")
    }

    if (this.comparisons.length > 1) {
      this.ComparisonsCountTargets.map((target) => target.innerHTML = this.comparisons.length)
      this.ComparisonsButtonTargets.map((target) => target.classList.remove("hidden"))
    } else {
      this.ComparisonsButtonTargets.map((target) => target.classList.add("hidden"))
    }

    this.ComparisonTableColumnTargets.map((target) => {
      if (this.comparisons.find((listing) => listing.id == target.dataset.id)) {
        target.classList.remove("hidden")
      } else {
        target.classList.add("hidden")
      }
    })
  }

  onComparisonClick(e) {
    this.ComparisonsContainerTarget.classList.remove("hidden")
    this.HybridsContainerTarget.classList.add("hidden")

    setTimeout(function () {
      var yOffset = -50;
      var y = this.ComparisonsContainerTarget.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }.bind(this), 100)
  }

  onHideComparison(e) {
    this.ComparisonsContainerTarget.classList.add("hidden")
    this.HybridsContainerTarget.classList.remove("hidden")
  }

  onToggleMobileFiltersExpanded(e) {
    this.mobileFiltersExpanded = !this.mobileFiltersExpanded

    if (this.mobileFiltersExpanded) {
      this.FilterToggleOpenCaretTarget.classList.add("hidden")
      this.FilterToggleCloseCaretTarget.classList.remove("hidden")
      this.FiltersContainerTarget.classList.remove("hidden")
      this.FilterToggleTextTarget.innerHTML = "Less"
    } else {
      this.FilterToggleOpenCaretTarget.classList.remove("hidden")
      this.FilterToggleCloseCaretTarget.classList.add("hidden")
      this.FiltersContainerTarget.classList.add("hidden")
      this.FilterToggleTextTarget.innerHTML = "More"
    }
  }

  onStateChange(e) {
    this.selectedState = e.currentTarget.value
    if (this.selectedState == '') {
      this.selectedState = null
    }

    this.filterMatches()
    this.displayClearFilters()
  }

  onCategoryClick(e) {
    var category = e.currentTarget.value
    this[`category${category}`] = !this[`category${category}`]

    if (this[`category${category}`]) {
      this[`FilterContainerCategory${category}Target`].classList.add("bg-highlight-blue", "rounded")
    } else {
      this[`FilterContainerCategory${category}Target`].classList.remove("bg-highlight-blue", "rounded")
    }

    this.filterMatches()
    this.displayClearFilters()
  }

  onPurposeClick(e) {
    this.purpose = e.currentTarget.value

    this.FilterContainerPurposeTargets.map((target) => {
      const purposeValue = target.dataset.purposeValue
      if (purposeValue != this.purpose) {
        target.classList.remove("bg-highlight-blue", "rounded")
      } else {
        target.classList.add("bg-highlight-blue", "rounded")
      }
    })

    if (this.purpose == "FoodPlot") {
      this.FoodPlotLabelTargets.map((target) => target.classList.remove("hidden"))
    } else {
      this.FoodPlotLabelTargets.map((target) => target.classList.add("hidden"))
    }

    if (this.purpose == "FoodGrade") {
      this.FoodGradeLabelTargets.map((target) => target.classList.remove("hidden"))
    } else {
      this.FoodGradeLabelTargets.map((target) => target.classList.add("hidden"))
    }

    this.filterMatches()
    this.displayClearFilters()

    if (this.hybridFinderController()) {
      this.hybridFinderController().onFilterClick('purpose', this.purpose)
    }
  }

  onDroughtToleranceClick(e) {
    this.droughtTolerance = e.currentTarget.value

    this.FilterContainerDroughtToleranceTargets.map((target) => {
      const droughtToleranceValue = target.dataset.droughtToleranceValue
      if (droughtToleranceValue != this.droughtTolerance) {
        target.classList.remove("bg-highlight-blue", "rounded")
      } else {
        target.classList.add("bg-highlight-blue", "rounded")
      }
    })

    this.filterMatches()
    this.displayClearFilters()
  }

  onSoilTypeClick(e) {
    this.soilType = e.currentTarget.value

    this.FilterContainerSoilTypeTargets.map((target) => {
      const soilTypeValue = target.dataset.soilTypeValue
      if (soilTypeValue != this.soilType) {
        target.classList.remove("bg-highlight-blue", "rounded")
      } else {
        target.classList.add("bg-highlight-blue", "rounded")
      }
    })

    this.filterMatches()
    this.displayClearFilters()
  }

  onDiseaseToleranceClick(e) {
    var diseaseTolerance = e.currentTarget.value

    this[`diseaseTolerance${diseaseTolerance}`] = !this[`diseaseTolerance${diseaseTolerance}`]

    if (this[`diseaseTolerance${diseaseTolerance}`]) {
      this[`FilterContainerDiseaseTolerance${diseaseTolerance}Target`].classList.add("bg-highlight-blue", "rounded")
    } else {
      this[`FilterContainerDiseaseTolerance${diseaseTolerance}Target`].classList.remove("bg-highlight-blue", "rounded")
    }

    this.filterMatches()
    this.displayClearFilters()
  }

  stopPropagation(e) {
    e.stopPropagation()
  }

  filterMatches() {
    var matches = this.filterMaturityRangeMatches(this.listings)
    matches = this.filterStateMatches(matches)
    matches = this.filterCategoryMatches(matches)
    matches = this.filterPurposeMatches(matches)
    matches = this.filterDroughtToleranceMatches(matches)
    matches = this.filterSoilTypeMatches(matches)
    matches = this.filterDiseaseToleranceMatches(matches)
    this.listingMatches = matches

    this.filterOutComparisons()

    const resultsCountText = this.listingMatches.length
    if (this.hasResultsCountTarget) {
      this.ResultsCountTarget.innerHTML = resultsCountText
    }

    this.ListingContainerTargets.map((listingContainer) => {
      const listingId = listingContainer.dataset.listingId
      if (this.listingMatches.find(((lm) => lm.id == listingId))) {
        listingContainer.classList.remove("hidden")
      } else {
        listingContainer.classList.add("hidden")
      }
    })

    if (this.hybridFinderController()) {
      this.hybridFinderController().onHybridsFilterMatches(this.listingMatches)
    }
  }

  filterOutComparisons() {
    this.comparisons = this.comparisons.filter((listing) => this.listingMatches.find((match) => match.id == listing.id))

    if (this.comparisons.length > 0) {
      this.ComparisonsCountTargets.map((target) => target.innerHTML = this.comparisons.length)
      if (this.comparisons.length > 1) {
        this.ComparisonsButtonTargets.map((target) => target.classList.remove("hidden"))
      } else {
        this.ComparisonsButtonTargets.map((target) => target.classList.add("hidden"))
      }

      this.listings.map((listing) => {
        if (!this.comparisons.find((comparee) => comparee.id == listing.id)) {
          const elem = this.CompareButtonTargets.find((target) => target.dataset.id == listing.id)
          const listingContainer = this.ListingMainTargets.find((target) => target.dataset.id == listing.id)
          elem.classList.remove("bg-ux-blue-400", "!text-white", "hover:bg-gray-500", "border-0")
          elem.querySelector('[data-icon]').classList.add("hidden")
          listingContainer.classList.remove("!border-3", "!border-ux-blue-400")
        }
      })
    } else {
      this.ComparisonsButtonTargets.map((target) => target.classList.add("hidden"))
      this.CompareButtonTargets.map((target) => {
        target.classList.remove("bg-ux-blue-400", "!text-white", "hover:bg-gray-500", "border-0")
        target.querySelector('[data-icon]').classList.add("hidden")
      })
      this.ListingMainTargets.map((target) => {
        target.classList.remove("!border-3", "!border-ux-blue-400")
      })

    }
  }

  filterMaturityRangeMatches(listings) {
    return listings.filter((listing) => this.rmRangeLow <= listing.days_to_maturity && listing.days_to_maturity <= this.rmRangeHigh)
  }

  filterStateMatches(listings) {
    return listings.filter((listing) => this.selectedState == null || (listing.states_search_list && listing.states_search_list.includes(this.selectedState)))
  }

  filterCategoryMatches(listings) {
    return listings.filter((listing) => {
      var match = true
      if (this.categoryPerformer) {
        match = listing.category.toLowerCase().indexOf("performer") >= 0
      }
      if (this.categoryAdaptable) {
        match = listing.category.toLowerCase().indexOf("adaptable") >= 0 || listing.category.toLowerCase().indexOf("reliable") >= 0
      }
      if (this.categoryTough) {
        match = listing.category.toLowerCase().indexOf("tough") >= 0
      }
      return match
    })
  }

  filterPurposeMatches(listings) {
    return listings.filter((listing) => {
      var match = true
      if (this.purpose == "Silage") {
        match = listing.purpose.indexOf("silage") >= 0
      }
      if (this.purpose == "Grain") {
        match = listing.purpose.indexOf("grain") >= 0
      }
      if (this.purpose == "FoodPlot") {
        match = listing.purpose.indexOf("food_plot") >= 0
      }
      if (this.purpose == "FoodGrade") {
        match = listing.purpose.indexOf("food_grade") >= 0
      }
      return match
    })
  }

  filterDroughtToleranceMatches(listings) {
    return listings.filter((listing) => {
      var match = true
      if (this.droughtTolerance == "Dryland") {
        match = listing.drought_tolerance.indexOf("dryland") >= 0
      }
      if (this.droughtTolerance == "Irrigated") {
        match = listing.drought_tolerance.indexOf("irrigated") >= 0
      }
      return match
    })
  }

  filterSoilTypeMatches(listings) {
    return listings.filter((listing) => {
      var match = true
      if (this.soilType == "Productive") {
        match = listing.soil_type.indexOf("productive") >= 0
      }
      if (this.soilType == "Marginal") {
        match = listing.soil_type.indexOf("marginal") >= 0
      }
      return match
    })
  }

  filterDiseaseToleranceMatches(listings) {
    return listings.filter((listing) => {
      var match = true
      if (this.diseaseToleranceGoss) {
        match = listing.disease_tolerances.indexOf("goss's wilt") >= 0
      }
      if (this.diseaseToleranceGray) {
        match = (
          listing.disease_tolerances.indexOf("gray leaf spot") >= 0
        )
      }
      if (this.diseaseToleranceBlight) {
        match = listing.disease_tolerances.indexOf("northern leaf blight") >= 0
      }
      if (this.diseaseToleranceAnthracnose) {
        match = (
          listing.disease_tolerances.indexOf("stalk anthracnose") >= 0
        )
      }
      return match
    })
  }

  displayClearFilters() {
    const showClearFilters = (
      this.rmRangeLow != this.defaultRmRangeLow ||
      this.rmRangeHigh != this.defaultRmRangeHigh ||
      this.categoryPerformer == true ||
      this.categoryAdaptable == true ||
      this.categoryTough == true ||
      this.purpose !== null ||
      this.droughtTolerance !== null ||
      this.soilType !== null ||
      this.diseaseToleranceGoss == true ||
      this.diseaseToleranceGray == true ||
      this.diseaseToleranceBlight == true ||
      this.diseaseToleranceAnthracnose == true ||
      this.selectedState != null
    )

    if (this.hasClearFiltersButtonTarget) {
      if (showClearFilters) {
        this.ClearFiltersButtonTarget.classList.remove("hidden")
        this.ClearFiltersButtonTarget.classList.add("flex")
        this.ClearFiltersButtonFilterBarTargets.map((target) => target.classList.remove("hidden"))
        this.ClearFiltersButtonFilterBarTargets.map((target) => target.classList.add("sm:flex"))
      } else {
        this.ClearFiltersButtonTarget.classList.add("hidden")
        this.ClearFiltersButtonTarget.classList.remove("sm:flex")
        this.ClearFiltersButtonFilterBarTargets.map((target) => target.classList.remove("sm:flex"))
        this.ClearFiltersButtonFilterBarTargets.map((target) => target.classList.add("hidden"))
      }
    }
  }

  onDownloadSpecPdf() {
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'download product pdf',
        'conversionValue': 15.00
      })
    }
    // if (window.gtag) {
    //   gtag('event', 'download product pdf', { event_category: 'Lead', currency: 'USD', value: 15.00 })
    //   gtag('event', 'conversion', {'send_to': 'AW-779913037/x5uCCNiwg40BEM2O8vMC', 'currency': 'USD', 'value': 15.00})
    // }
    // if (window.fbq) {
    //   fbq('trackCustom', 'download product pdf', { currency: 'USD', value: 15.00 })
    // }
    // if (window.uetq) {
    //   window.uetq.push('event', 'other', {"revenue_value":15.00,"currency":"USD"});
    // }
  }

}
